import BaseComponent from '@/components/base';
import ProgressBarStyle from '@/components/progress-bar/style';
import { FontStyle } from '@/components/style';

export default class ProgressBar extends BaseComponent {
  render() {
    return `
    ${FontStyle}
    ${ProgressBarStyle}

    <div class="progress-bar-container">
        <div class="text-container">
            <div class="body-font-2">${this.leftLabel}</div>
            <div class="body-font-2">${this.rightLabel}</div>
        </div>
        <div class="progress-container">
            <div class="progress-move" style="width: ${this.percentage}%"></div>
        </div>
    </div>
    `;
  }

  get leftLabel() {
    return this.getAttribute('leftLabel');
  }

  set leftLabel(value) {
    this.setAttribute('leftLabel', value);
  }

  get rightLabel() {
    return this.getAttribute('rightLabel');
  }

  set rightLabel(value) {
    this.setAttribute('rightLabel', value);
  }

  get percentage() {
    return this.getAttribute('percentage');
  }

  set percentage(value) {
    this.setAttribute('percentage', value);
  }
}
